import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Costanti from "../../constantiX";
import { useHistory } from 'react-router-dom';
import { InputText,Checkbox,Button,Toast,Image, RadioButton  } from "primereact";
import {AuthService} from '../../services/AuthService';
import ReactGA from 'react-ga4';

class Wallet extends React.Component {
  constructor() {
    super();


    this.state = {viewdett:false,activeIndex:0,loading:false, dati:[],grafici:[], activePage:1, totalRecords:0, pageSize:10, first:0, visible2: false,visible3: false , singolo:{}};
    this.token=sessionStorage.getItem("ICEtoken");
    this.utente=JSON.parse(sessionStorage.getItem("utente"));
  
  }



  componentDidMount() {
    //alert(this.props.location.pathname);
    ReactGA.send('pageview',this.props.location.pathname);
    this.caricaDati(1,1);
 }

 caricaDati(pagina,numrec){
  let config = {
      headers: {
        'Authorization': 'Bearer ' + this.token
      }
    }
    this.setState({loading:true});
   var quer='page='+pagina+'&num='+numrec+'&aziendaid='+this.utente.aziendaid+'&tipo=1';
  axios.get(Costanti.UrlCallApi+"notarizzazione/all?"+quer,config)
  .then(res => {
      res.data.lista1.forEach(element => {
          element.azioni=this.actions
      });
      this.setState({dati:res.data.lista1,totalRecords:res.data.conta1+9900,loading:false})
      
      //alert(JSON.stringify(this.state.prodotti))
     }).catch(error=> {
       alert(error)
  });
} 

      showMessage(messageError,tipo) {
        var icona='';
        if(tipo=='error'){
          icona='pi pi-times-circle';
        }
        if(tipo=='info'){
          icona='pipi-info-circle';
        }
        if(tipo=='success'){
          icona='pi pi-check-circle';
        }
        if(tipo=='warning'){
          icona='pi pi-exclamation-triangle';
        }
        this.toastBC.show({ severity: tipo,  life: 3000, closable: false, content: (
            <div className="flex flex-column" style={{flex: '1'}}>
                <div className="text-center">
                 <i className={icona} style={{fontSize: '3rem'}}></i>
                    <h4>{messageError}</h4>
                </div>
            </div>
        ) });
      }
      render() {
        return( 
        <div>
         <div className="flex flex-column mt-8" style={{ alignItems: "center", justifyItems: "center", gap: "1rem" }}>
            <Image src="./assets/ICE-images/algorandLogo.svg" alt="Image" width="150" />
            <div className="flex flex-column" style={{ alignItems: "center" }}>
                <h4 className="font-bold m-0">CREDITI</h4>
                <h4 className="font-bold text-yellow-400 m-0">{(10000-this.state.totalRecords)} / 100 annui</h4>
            </div>
            {/*<div className="flex flex-column" style={{ alignItems: "center" }}>
                <h4 className="font-bold text-yellow-400 m-0">WALLET ATTIVO</h4>
                <h5 className="m-0">(02/05/2021, 11:45 am)</h5>
        </div>*/}
        </div>
   
        <div className="flex">
             <Toast ref={(el) => this.toastBC = el} position="bottom-center" />
        </div>
        </div>  
      )  
    }
    }

    export default Wallet;